import { z } from 'zod'
import { oc } from '@orpc/contract'
import { boardItemSchema } from '../../boards/handlers/boards-shared.contract'

// RingCentral message ids are plain numeric strings. The pattern also keeps a
// path-traversing or URL-shaped value out of the `/fax/sent/<id>` link the web
// builds from whatever is stored here.
export const outgoingFaxMessageId = z
  .string()
  .trim()
  .min(1)
  .max(64)
  .regex(/^[A-Za-z0-9._-]+$/, 'messageId must be a plain RingCentral message id')

/**
 * Record a sent fax against a care task (PD-1606). Purely a record: the task's
 * status, group, checklist and completion are untouched.
 */
export const linkOutgoingFax = oc
  .route({ method: 'POST', path: '/v2/fax-tasks/outgoing-links' })
  .input(
    z.object({
      itemId: z.string().min(1),
      messageId: outgoingFaxMessageId,
      // Display snapshots the caller reads off the sent-fax record, stored so
      // the link still reads correctly once the fax is deleted from RingCentral.
      // Not verified against RingCentral: the message id is opaque data, and
      // `/fax/sent/:messageId` already renders any id a user types into the URL,
      // so storing one grants no access they did not already have. What IS
      // enforced is the task side — the item must belong to the caller's org.
      recipient: z.string().trim().min(1).max(200),
      sentAt: z.string().datetime(),
      note: z.string().trim().min(1).max(500).optional(),
    }),
  )
  .output(z.object({ item: boardItemSchema }))
